import React from 'react';
import { motion } from 'framer-motion';
import { DashboardMock, SkillsLibraryMock, EfficiencyChartMock, CertificateMock } from './graphics/Mockups';
const deliverables = [{
  title: 'Live Usage Dashboards',
  desc: 'Monitor AI adoption across your organization in real-time.',
  mockup: <DashboardMock data-id="element-57" />
}, {
  title: 'Agent Skills Library',
  desc: 'A centralized repository of custom agent workflows your team can download and use.',
  mockup: <SkillsLibraryMock data-id="element-58" />
}, {
  title: 'Efficiency Tracking',
  desc: 'Clear metrics showing time saved and output increased per department.',
  mockup: <EfficiencyChartMock data-id="element-59" />
}, {
  title: 'Certified Workforce',
  desc: 'Official certification ensuring your team meets the new standard of operation.',
  mockup: <CertificateMock data-id="element-60" />
}];
export function DeliverablesSection() {
  return <section id="deliverables" className="py-24 md:py-32 bg-background" data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-62">
        <div className="mb-16 md:mb-24 max-w-2xl" data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-64">
            What We Leave Behind
          </h2>
          <p className="text-lg text-neutral-600" data-id="element-65">
            We don't just train and leave. We build the infrastructure you need
            to sustain and scale your AI operations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-66">
          {deliverables.map((item, i) => <motion.div key={i} className="bg-white p-8 rounded-2xl border border-neutral-200 flex flex-col" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} viewport={{
          once: true
        }} data-id="element-67">
              <div className="h-64 mb-8 bg-neutral-50 rounded-xl p-4 border border-neutral-100" data-id="element-68">
                {item.mockup}
              </div>
              <h3 className="text-2xl font-serif mb-3" data-id="element-69">{item.title}</h3>
              <p className="text-neutral-600" data-id="element-70">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}